var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import cx from 'clsx';
import { innerWrapperStyles, sectionVariants } from './PageBlock.css';
export const PageBlock = React.forwardRef(function Stack(_a, ref) {
    var { as, children, className, withPaddingY } = _a, rest = __rest(_a, ["as", "children", "className", "withPaddingY"]);
    const Component = as || 'div';
    return (_jsx(Component, Object.assign({}, rest, { className: cx(sectionVariants[withPaddingY ? 'withBlockPadding' : 'default'], className), ref: ref, children: _jsx("div", { className: innerWrapperStyles, children: children }) })));
});
